import { performanceMeasureEnd, performanceMeasureStart } from './dev_tools';
import { ENV } from './global_options';
export class FuncArr {
    constructor(type) {
        this.empty = true;
        /* @internal */
        this._$arr = null;
        this._$type = type;
    }
    add(func) {
        if (!this._$arr)
            this._$arr = [func];
        else
            this._$arr = this._$arr.concat(func);
        this.empty = false;
    }
    remove(func) {
        let ret = null;
        if (this._$arr) {
            const newArr = [];
            const oldArr = this._$arr;
            for (let i = 0; i < oldArr.length; i += 1) {
                if (oldArr[i] === func) {
                    newArr.push(...oldArr.slice(i + 1));
                    ret = func;
                    break;
                }
                newArr.push(oldArr[i]);
            }
            this._$arr = newArr;
            this.empty = this._$arr.length === 0;
        }
        return ret;
    }
    call(caller, args, relatedComponent) {
        const arr = this._$arr;
        let ret = true;
        if (arr) {
            for (let i = 0; i < arr.length; i += 1) {
                const r = safeCallback(this._$type, arr[i], caller, args, relatedComponent);
                if (r === false)
                    ret = false;
            }
        }
        return ret;
    }
}
export class FuncArrWithMeta {
    constructor(type) {
        this.empty = true;
        this._$arr = null;
        this._$type = type;
    }
    getArr() {
        return this._$arr;
    }
    hasFunc() {
        return this._$arr !== null && this._$arr.length > 0;
    }
    add(func, data) {
        const item = { f: func, data };
        if (!this._$arr)
            this._$arr = [item];
        else
            this._$arr = this._$arr.concat(item);
        this.empty = false;
    }
    remove(func) {
        let ret = null;
        if (this._$arr) {
            const newArr = [];
            const oldArr = this._$arr;
            for (let i = 0; i < oldArr.length; i += 1) {
                const v = oldArr[i];
                if (v.f === func) {
                    newArr.push(...oldArr.slice(i + 1));
                    ret = v.data;
                    break;
                }
                newArr.push(v);
            }
            this._$arr = newArr;
            this.empty = this._$arr.length === 0;
        }
        return ret;
    }
    call(caller, args, retainFn, relatedComponent, handleReturn) {
        const arr = this._$arr;
        let ret = true;
        if (arr) {
            for (let i = 0; i < arr.length; i += 1) {
                const { f, data } = arr[i];
                if (!retainFn(data))
                    continue;
                const rawReturn = safeCallback(this._$type, f, caller, args, relatedComponent);
                const r = handleReturn ? handleReturn(rawReturn) : rawReturn;
                if (r === false)
                    ret = false;
            }
        }
        return ret;
    }
}
let dispatchError = () => { };
export function _setErrorDispatcher(dispatcher) {
    dispatchError = dispatcher;
}
export function safeCallback(type, method, caller, args, relatedComponent) {
    try {
        if (ENV.DEV)
            performanceMeasureStart(`${type}.${method.name || '(anonymous)'}`, relatedComponent, { args });
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return method.apply(caller, args);
    }
    catch (e) {
        dispatchError(e, `${type || 'Listener'} ${method.name || '(anonymous)'}`, relatedComponent);
        return undefined;
    }
    finally {
        if (ENV.DEV)
            performanceMeasureEnd();
    }
}
//# sourceMappingURL=func_arr.js.map